export default __webpack_public_path__ + "static/media/date-icon.6a2a9aee.svg";